import { __assign, __rest } from "tslib";
import React from 'react';
import { Box, Tooltip, CircleButton, Icon } from '@marvelapp/ui';
import { ARROW_UP_ICON } from '@marvelapp/theme';
export default function MoveUpButton(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Box, { marginRight: 2 },
        React.createElement(Tooltip, { content: "Move section up" },
            React.createElement(CircleButton, __assign({ bg: "white", "data-testid": "move-section-up-button", hoverBg: "white" }, props),
                React.createElement(Icon, { display: "block", height: 20, paths: ARROW_UP_ICON, width: 20 })))));
}
